var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    buttons: true,
    'buttons--bottom': _vm.align === `bottom`,
    'buttons--middle-right': _vm.align === `middle-right`,
  }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }